// extracted by mini-css-extract-plugin
module.exports = {"main-component":"highPriority_main-component__1wB2E"};